import React from 'react'
import PropTypes from 'prop-types'

import Provider from 'model/provider/provider'

import in_network_icon from 'assets/in_network_icon.svg'
import out_of_network_icon from 'assets/out_of_network_icon.svg'

import { TierWrap, TierIcon } from './styled'

const OON = 'out_of_network'

const ProviderTier = ({ provider }) => {
  const { insurance_tier } = provider

  if (!insurance_tier || !insurance_tier?.name) return false
  const icon =
    insurance_tier.name === OON ? out_of_network_icon : in_network_icon

  return (
    <TierWrap data-test="providerTier">
      <TierIcon>
        <img src={icon} alt="Tier" />
      </TierIcon>{' '}
      {insurance_tier?.name}
    </TierWrap>
  )
}

ProviderTier.propTypes = {
  provider: PropTypes.instanceOf(Provider).isRequired
}

export default ProviderTier
